<template>
    <div class="clearfix main_center">
        <div class="right-content">
            <el-form ref="form" :model="form" label-width="180px" :rules="rules" >
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>项目信息</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="项目名称：" size="small" prop="projectName">
                                    <el-select v-model="form.projectName"
                                               placeholder="请输入项目名称搜索"
                                               filterable
                                               remote
                                               reserve-keyword
                                               :remote-method="remoteProjectInfo"
                                               :loading="projectLoading"
                                               @change="handleChangeProject"
                                    >
                                        <el-option
                                            v-for="item in projectOptions"
                                            :key="item.projectEntryId"
                                            :label="item.projectName"
                                            :value="item.projectEntryId">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="招标（采购）人：" size="small" prop="tendererName">
                                    <el-input v-model="form.tendererName" placeholder="根据选择的项目自动带出" disabled/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="招标（采购）项目内容：" size="small" prop="tenderContent">
                                    <el-input type="textarea"
                                              v-model="form.tenderContent"
                                              placeholder="根据选择的项目自动带出"
                                              disabled
                                              :rows="5"
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card class="box-card" v-if="form.history">
                    <div slot="header" class="clearfix">
                        <span>原预约信息</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="开标场地：" size="small">
                                    {{ form.history?.openVenue }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="使用开始时间：" size="small">
                                    {{ form.history?.openStartTime }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="使用结束时间：" size="small">
                                    {{ form.history?.openEndTime }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="评标场地：">
                                    <div class="placesChose" style="display: flex">
                                        {{ form.history?.evalVenue }}
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="使用开始时间：">
                                    {{ form.history?.evalStartTime }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="使用结束时间：">
                                    {{ form.history?.evalEndTime }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="备注：" size="small">
                                    {{ form.history?.remarks }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>场地预约信息</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="开标场地：" size="small" prop="openVenue">
                                    <div class="placesChose" style="display: flex">
                                        <el-input v-model="form.openVenue" disabled></el-input>
                                        <el-button type="primary" style="margin-left:15px" @click="chosePlace('1')">选择</el-button>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-if="form.history">
                                <el-form-item label="变更次数：" size="small" >
                                    {{ form.changeCount || 0 }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="使用开始时间：" size="small" prop="openStartTime">
                                    <el-date-picker
                                        v-model="form.openStartTime"
                                        type="datetime"
                                        :disabled="true"
                                        style="width: 100%"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择日期时间">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="使用结束时间：" size="small" prop="openEndTime">
                                    <el-date-picker
                                        v-model="form.openEndTime"
                                        type="datetime"
                                        :disabled="true"
                                        style="width: 100%"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择日期时间">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="评标场地：">
                                    <div class="placesChose" style="display: flex">
                                        <el-input v-model="form.evalVenue" disabled></el-input>
                                        <el-button type="primary" style="margin-left:15px" @click="chosePlace('2')">选择</el-button>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="使用开始时间：">
                                    <el-date-picker
                                        v-model="form.evalStartTime"
                                        type="datetime"
                                        :disabled="true"
                                        style="width: 100%"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择日期时间">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="使用结束时间：">
                                    <el-date-picker
                                        v-model="form.evalEndTime"
                                        type="datetime"
                                        :disabled="true"
                                        style="width: 100%"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择日期时间">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="备注：" size="small">
                                    <el-input type="textarea"
                                              v-model="form.remarks"
                                              placeholder="请输入"
                                              :rows="5"
                                              maxlength="500"
                                              show-word-limit
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </el-form>
        </div>
        <div class="left-content">
            <div class="left-navbar">
                <el-button size="small"
                           type="primary"
                           @click="onClickSave"
                           :loading="saveLoading"
                >保存</el-button>
                <el-button size="small"
                           type="primary"
                           @click="onClickSubmit"
                           :loading="submitLoading"
                >提交</el-button>
                <el-button size="small" @click="backBtn">返回</el-button>
            </div>
        </div>
        <el-dialog
            title="场地选择"
            :visible.sync="centerDialogVisible"
            width="1400px"
            center>
            <site ref="siteRef" @getMessage="getMessage"></site>
        </el-dialog>
    </div>
</template>

<script>
import {tabsCloseCurrentHandle} from '@/utils/routeTab';
import site from './components/site.vue'

export default {
    components: {
        site,
    },
    data() {
        return {
            id: '',
            form: {},
            projectOptions: [],
            rules: {
                projectName: [
                    { required: true, message: '请选择项目名称', trigger: ['blur', 'change'] },
                ],
                tendererName: [
                    { required: true, message: '请输入招标（采购）联系人', trigger: ['blur', 'change'] },
                ],
                tenderContent: [
                    { required: true, message: '请输入招标（采购）内容', trigger: ['blur', 'change'] },
                ],
            },
            centerDialogVisible: false,
            chooseType: '1', //场地选择框类型，1开标，2评标
            saveLoading: false, //保存loading
            submitLoading: false, //提交loading
            projectLoading: false, //项目名称远程搜索loading
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        this.requestDetailData();
        this.requestProjectInfo();
    },
    methods: {
        //获取详情数据
        requestDetailData() {
            if (!this.id) {
                return
            }
            this.$http.get(`/suit/get?venueId=${this.id}`).then(({data}) => {
                if (data.code === '1') {
                    this.form = {...data.data}
                }
            })
        },
        //获取进场项目下拉框数据（支持按项目名称关键字搜索）
        requestProjectInfo(keywords) {
            this.projectLoading = true;
            this.$http.get(`/suit/projectInfo`, {
                params: { keywords: keywords || '' }
            }).then(({data}) => {
                this.projectOptions = data
            }).finally(() => {
                this.projectLoading = false;
            })
        },
        //项目名称远程搜索（搜索框为空时也请求列表）
        remoteProjectInfo(query) {
            this.requestProjectInfo(query);
        },
        //选择了项目
        handleChangeProject(val) {
            const selectProject = this.projectOptions.find(item => item.projectEntryId === val)
            if (selectProject) {
                this.form.projectEntryId = selectProject.projectEntryId;
                this.form.projectName = selectProject.projectName;
                this.form.tendererName = selectProject.tendererName;
                this.form.tenderContent = selectProject.tenderContent;
            }
        },
        //打开选择场地弹框
        chosePlace(type) {
            this.centerDialogVisible = true;
            this.chooseType = type;
            this.$nextTick(() => {
                this.$refs.siteRef.openChosePlace(type);
            })
        },
        //获取场地信息
        getMessage(data){
            this.centerDialogVisible=false;
            if (this.chooseType === '1') {
                this.form.openVenue = data.fieldName;
                this.form.openStartTime = data.applyTime;
                this.form.openEndTime = data.useEndTime;
                this.form.openVenueFieldId = data.fieldId;
                this.form.openVenueApplyTimeInterval = data.applyTimeInterval;
            } else {
                this.form.evalVenue = data.fieldName;
                this.form.evalStartTime = data.applyTime;
                this.form.evalEndTime = data.useEndTime;
                this.form.evalVenueFieldId = data.fieldId;
                this.form.evalVenueApplyTimeInterval = data.applyTimeInterval;
            }
        },
        //保存
        onClickSave() {
            if (!this.form.openVenue && !this.form.evalVenue) {
                this.$message.error('开标场地和评标场地至少选择一个');
                return
            }
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.saveLoading = true;
                    this.$http.post('/suit/saveOrUpdate', this.form).then(({data}) => {
                        if (data.code === '1') {
                            this.id = data.data.id;
                            this.form.id = data.data.id;
                            this.$message.success("保存成功！")
                        } else {
                            this.$message.error(data.msg)
                        }
                    }).finally(() => {
                        this.saveLoading = false;
                    })
                }
            })
        },
        onClickSubmit() { //提交
            if (!this.id) {
                this.$message.error('请先保存数据！')
                return
            }
            const params = {
                id: this.id
            }
            this.submitLoading = true;
            this.$http.post('/suit/submitProcess', params).then(({data}) => {
                if (data.code === '1') {
                    this.$message.success('提交成功！')
                    setTimeout(() => {
                        this.backBtn()
                    }, 1000)
                } else {
                    this.$message.error(data.msg)
                }
            }).finally(() => {
                this.submitLoading = false;
            })
        },
        getRowsIndex(index) {
            return index + 1
        },
        backBtn() { //返回
            tabsCloseCurrentHandle();
            this.$router.push({
                name: 'singleWindowServiceSiteList'
            })
            this.$refs.form.resetFields();
        },
    }


}
</script>

<style lang="less" scoped>
.angle_tag {
    margin-right: 10px !important;
}
</style>
